<template>
  <div>
    <div class="mask"> </div>
    <div class="miniview">
    <div class="loading-spacer"></div>
      <vue-loading
        type="spiningDubbles"
        color="#4169e1"
        :size="{ width: '20%' }"
      />
    </div>
  </div>
</template>

<script>
import { VueLoading } from 'vue-loading-template'

export default {
  name: 'loading',
  components: {
    VueLoading
  }
}
</script>

<style>
.mask{
  z-index : 9;
  width: 100%;
  height: 100%;
  background: black;
  position: fixed;
  top: 0;
  left: 0;
  opacity: 0.5;
  /* border-radius: 10rem; */
}
.miniview {
  z-index : 10;
  width: 80%;
  height: 20%;
  background: #cccccc;
  position: fixed;
  top: calc(100% - 60%);
  left: 10%;
  border-radius: 2rem;
  opacity: 1;
}
</style>



// WEBPACK FOOTER //
// src/components/Organisms/MiniLoading.vue